var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hls-player"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions,"playsinline":true,"custom-event-name":"customstatechangedeventname"},on:{"ready":_vm.playerReadied}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }